import React from "react";
import styles from "./AppContainer.module.css";
import classNames from "classnames";

const AppContainer = (props) => {
  return <div id={props.id} className={classNames(styles.left, {[props.className]: props.className})}>{props.children}</div>;
};

export default AppContainer;
